import { z } from "zod";

export type PaymentMethodId = "stripe" | "cash" | "paypal";

export interface PaymentMethodMeta {
  id: PaymentMethodId;
  label: string;
  shortLabel: string;
  emoji: string;
  description: string;
}

export const PAYMENT_METHODS: PaymentMethodMeta[] = [
  {
    id: "stripe",
    label: "Paiement sécurisé Click&Gard",
    shortLabel: "Sécurisé",
    emoji: "💳",
    description:
      "Paiement par carte bancaire, fonds conservés en séquestre jusqu'à validation de la prestation.",
  },
  {
    id: "cash",
    label: "Paiement en espèces",
    shortLabel: "Espèces",
    emoji: "💶",
    description: "Règlement direct en liquide entre vous et le professionnel.",
  },
  {
    id: "paypal",
    label: "Paiement PayPal",
    shortLabel: "PayPal",
    emoji: "🅿️",
    description:
      "Règlement direct via PayPal. L'identifiant PayPal du pro vous sera transmis après confirmation.",
  },
];

export const getAcceptedMethods = (profile: {
  accepts_stripe?: boolean | null;
  accepts_cash?: boolean | null;
  accepts_paypal?: boolean | null;
}): PaymentMethodMeta[] =>
  PAYMENT_METHODS.filter((m) => {
    if (m.id === "stripe") return profile.accepts_stripe !== false;
    if (m.id === "cash") return !!profile.accepts_cash;
    if (m.id === "paypal") return !!profile.accepts_paypal;
    return false;
  });

// PayPal identifier: email OR paypal.me link
export const paypalIdentifierSchema = z
  .string()
  .trim()
  .min(3, "Identifiant PayPal requis")
  .max(255, "Identifiant PayPal trop long")
  .refine(
    (v) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
      /^(https?:\/\/)?(www\.)?paypal\.me\/[a-zA-Z0-9._-]{1,64}\/?$/i.test(v),
    "Format invalide — email PayPal ou lien paypal.me/pseudo attendu",
  );

export const isDirectMethod = (m: PaymentMethodId | string | null | undefined) =>
  m === "cash" || m === "paypal";
